// Libs
import clsx from "clsx";
import type React from "react";

export interface ListItemTextProps {
    /**
     * Additional className
     */
    className?: string;
    /**
     * Primary information
     */
    primary?: React.ReactNode;
    /**
     * Secondary information
     */
    secondary?: React.ReactNode;

    /**
     * Additional className for primary text
     */
    primaryClassName?: string;
    /**
     * Additional className for primary text
     */
    secondaryClassName?: string;
}

export function ListItemText({
    className,
    primary,
    secondary,
    primaryClassName: primaryClassNameProps,
    secondaryClassName: secondaryClassNameProps,
    ...otherProps
}: ListItemTextProps) {
    const rootClassName = clsx("ds-c-list-item-text", className);
    const primaryClassName = clsx(
        "ds-c-list-item-text__primary",
        "ds-u-typography--body",
        primaryClassNameProps
    );
    const secondaryClassName = clsx(
        "ds-c-list-item-text__secondary",
        "ds-u-typography--body",
        secondaryClassNameProps
    );

    return (
        <div {...otherProps} className={rootClassName}>
            <div className={primaryClassName}>{primary}</div>
            {secondary && <div className={secondaryClassName}>{secondary}</div>}
        </div>
    );
}
